import { z } from "zod";
/** Control plane → Agent service: stop every active run started by or stored for an account. */
export const agentAccountWorkStopRequestSchema = z.object({
    schemaVersion: z.literal(1),
    userId: z.uuid(),
    reason: z.enum(["account_suspended", "account_deleted"]),
}).strict();
export const agentAccountWorkStopResultSchema = z.object({
    schemaVersion: z.literal(1),
    userId: z.uuid(),
    cancelledRuns: z.number().int().min(0),
}).strict();
/**
 * Control plane → Agent service: permanently delete an account's Agent state.
 * `retainedAppIds` are apps that stay with an organisation although the account
 * is their storage owner; their conversations and workspaces are kept.
 */
export const agentAccountRetireRequestSchema = z.object({
    schemaVersion: z.literal(1),
    userId: z.uuid(),
    operationId: z.uuid(),
    state: z.literal("retiring"),
    retainedAppIds: z.array(z.uuid()).max(10_000),
}).strict();
export const agentAccountRetireResultSchema = z.object({
    schemaVersion: z.literal(1),
    userId: z.uuid(),
    operationId: z.uuid(),
    state: z.literal("retired"),
}).strict();
//# sourceMappingURL=accounts.js.map